import { render, staticRenderFns } from "./ToolbarItem.vue?vue&type=template&id=0b132b94&scoped=true&"
import script from "./ToolbarItem.vue?vue&type=script&lang=ts&"
export * from "./ToolbarItem.vue?vue&type=script&lang=ts&"
import style0 from "./ToolbarItem.vue?vue&type=style&index=0&id=0b132b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b132b94",
  null
  
)

export default component.exports